import axios from "axios";
import { BASE_URL } from "../../util/Constants";
import {
  fechaEntre,
  fechaFinEvaluacion,
  fechaInicioEvaluacion,
  validActProfe,
  validActProfeComentable,
} from "../../util/Functions";
import HTTP from "../../util/Http";

const createActividad = async (actividad, alTerminar) => {
  const url = BASE_URL + "actividad";
  // CON AXIOS
  await HTTP.post(url, actividad).then((response) => {
    console.log(response.data);
    alTerminar(response.data);
  });
};

const updateActividad = async (actividad, alTerminar) => {
  const url = BASE_URL + "actividad/update";
  // CON AXIOS
  await HTTP.put(url, actividad).then((response) => {
    console.log(response.data);
    alTerminar(response.data);
  });
};

const deleteActividad = async (actividad, alTerminar) => {
  const url = BASE_URL + "actividad/" + actividad.id;
  // CON AXIOS
  await HTTP.delete(url).then((response) => {
    console.log(response.data);
    alTerminar(actividad);
  });
};

const getActividadById = async (setActividad, id, token) => {
  const url = BASE_URL + "actividadDTO/" + id;

  // CON AXIOS
  await HTTP.get(url).then((response) => setActividad(response.data));
};

const actividadesPublicadas = async (setActividades) => {
  const url = BASE_URL + "actividades";
  const peticion = await axios.get(url);
  const res = peticion.data;
  console.log(res);
  var filtradas = filtrarActividadesPublicadas(res);

  filtradas.sort((a, b) => {
    const a_fechaini = new Date(a.fechaInicio);
    const b_fechaini = new Date(b.fechaInicio);
    return b_fechaini - a_fechaini;
  });
  setActividades(filtradas);
};

const actividadesPublicadasEval = async (evaluacion, setActividades) => {
  const url = BASE_URL + "actividades";
  const peticion = await axios.get(url);
  const res = peticion.data;
  console.log(res);
  var filtradas = filtrarActividadesPublicadas(res);
  var filtradasEval = filtrarActividadesEval(evaluacion, filtradas);

  filtradasEval.sort((a, b) => {
    const a_fechaini = new Date(a.fechaInicio);
    const b_fechaini = new Date(b.fechaInicio);
    return b_fechaini - a_fechaini;
  });
  setActividades(filtradasEval);
};

const actividadesPublicadasGrupo = async (grupo, setActividades) => {
  const url = BASE_URL + "actividades";
  const peticion = await axios.get(url);
  const res = peticion.data;
  console.log(res);
  var filtradas = filtrarActividadesPublicadas(res);
  var filtradasEval = filtrarActividadesGrupo(grupo, filtradas);

  filtradasEval.sort((a, b) => {
    const a_fechaini = new Date(a.fechaInicio);
    const b_fechaini = new Date(b.fechaInicio);
    return b_fechaini - a_fechaini;
  });
  setActividades(filtradasEval);
};

const misActividades = async (setActividades, user) => {
  const url = BASE_URL + "actividades";
  const peticion = await axios.get(url);
  const res = peticion.data;
  console.log(res);
  var filtradas = filtrarActividadesProfesor(res, user);
  filtradas.sort((a, b) => {
    const a_fechaini = new Date(a.fechaInicio);
    const b_fechaini = new Date(b.fechaInicio);
    return b_fechaini - a_fechaini;
  });
  setActividades(filtradas);
};

const actividadesNoValidadas = async (setActividades, user) => {
  const url = BASE_URL + "actividades";
  const peticion = await axios.get(url);
  const res = peticion.data;
  console.log(res);
  var filtradas = filtrarActividadesNoValidadas(res, user);
  filtradas.sort((a, b) => {
    const a_fechaini = new Date(a.fechaInicio);
    const b_fechaini = new Date(b.fechaInicio);
    return b_fechaini - a_fechaini;
  });
  setActividades(filtradas);
};

const filtrarActividadesProfesor = (actividades, user) => {
  const result = actividades.filter(
    (act) => validActProfe(act, user) || validActProfeComentable(act, user)
  );
  return result;
};

const filtrarActividadesPublicadas = (actividades) => {
  const result = actividades.filter(
    (act) => act.activado === true && !(act.archivada === true)
  );
  return result;
};

const filtrarActividadesEval = (evaluac, actividades) => {
  const result = actividades.filter((act) =>
    fechaEntre(
      act.fechaInicio,
      fechaInicioEvaluacion(evaluac),
      fechaFinEvaluacion(evaluac)
    )
  );
  return result;
};

const filtrarActividadesGrupo = (grupo, actividades) => {
  const result = actividades.filter((act) =>
    act.grupos?.some((g) => {
      return g.nombre === grupo;
    })
  );
  return result;
};

const filtrarActividadesNoValidadas = (actividades) => {
  const result = actividades.filter(
    (act) => act.activado === false && !(act.archivada === true)
  );
  return result;
};

export {
  actividadesPublicadas,
  actividadesNoValidadas,
  misActividades,
  getActividadById,
  updateActividad,
  createActividad,
  deleteActividad,
  actividadesPublicadasEval,
  actividadesPublicadasGrupo,
};
